import { useMemo } from 'react';

import { Button, Card } from 'antd';

import useProductStore from '@/stores/productStore';

import { Modrawer } from '../Modrawer';

type FixedFeeProps = {
  openTaxes: boolean;
  setOpenTaxes: (open: boolean) => void;
};

const FixedFee = ({ openTaxes, setOpenTaxes }: FixedFeeProps) => {
  const price = useProductStore(p => p.payment.price);
  const fee = useMemo(() => {
    if (price && price <= 30) {
      return '0%';
    }

    return '4,9%';
  }, [price]);

  return (
    <Modrawer
      open={openTaxes}
      title={<div className='text-center'>Entenda as taxas</div>}
      onCancel={() => setOpenTaxes(false)}
      footer={[
        <Button
          className='w-full md:w-auto'
          id='btn-ok-taxes'
          type='primary'
          key='ok'
          onClick={() => setOpenTaxes(false)}
        >
          Entendi
        </Button>
      ]}
    >
      <div className='flex flex-col gap-2 px-2 py-4'>
        <div className='text-content-title text-sm'>Essas taxas são cobradas por cada venda realizada.</div>

        <Card
          size='small'
          className='lg:min-w-118'
          classNames={{ body: 'grid h-36 grid-cols-[35%_20%_10%_35%] gap-2 px-3 py-2' }}
        >
          <div className='col-start-2'>Taxa Fixa</div>
          <div className='col-start-4'>Por venda</div>
          <div className='text-black/ text-content-title flex items-center gap-1 font-semibold'>
            <div className='h-4 w-4 rounded-full bg-yellow-500'></div>
            Eduzz
          </div>
          <div className='text-content-title font-semibold'>{fee}</div>
          <div>+</div>
          <div className='text-content-title font-semibold'>R$ 2,49</div>
          <div className='flex items-center gap-1'>
            <div className='h-4 w-4 rounded-full bg-orange-600'></div>
            Empresa 2
          </div>
          <div>9,9%</div>
          <div>+</div>
          <div>R$ 1,00</div>
          <div className='flex items-center gap-1'>
            <div className='h-4 w-4 rounded-full bg-emerald-600'></div>
            Empresa 3
          </div>
          <div>8,99%</div>
          <div>+</div>
          <div>R$ 2,49</div>
        </Card>
        <small className='text-content-subtitle text-sm'>
          Se o preço do produto for R$30 ou menos, a taxa fixa não será cobrada.
        </small>
      </div>
    </Modrawer>
  );
};

export default FixedFee;
